/**
 * 通用枚举的key枚举
 * 用于给get_enum_list_map接口提供入参key以获取对应的枚举list
 * @export
 * @enum {number}
 */
export enum CommonEnumKey {
  // ----------事故单部分----------
  ACCIDENT_RESPONSIBLE_ENUM = 'ACCIDENT_RESPONSIBLE_ENUM', // 技术支持判定的有责无责
  NEW_ACCIDENT_LEVEL_ENUM = 'NEW_ACCIDENT_LEVEL_ENUM', // 事故等级分类（即技术支持定级）
  SYSTEM_ACCIDENT_LEVEL_ENUM = 'SYSTEM_ACCIDENT_LEVEL_ENUM', // 系统定级（即事故等级+有无责任意义上的合并字段）
  THOROUGH_ACCIDENT_TYPE_ENUM = 'THOROUGH_ACCIDENT_TYPE_ENUM', // 事故分类枚举

  // ----------车型部分----------
  VEHICLE_TYPE_TAG = 'VEHICLE_TYPE_TAG', // 车型标签枚举

  // ----------车辆部分----------
  VEHICLE_SUPPLIER_ENUM = 'VEHICLE_SUPPLIER_ENUM', //车辆供应商

  VEHICLE_STATE_ENUM = 'VEHICLE_STATE_ENUM',
  ALARM_EVENT_ENUM = 'ALARM_EVENT_ENUM',
  SYSTEM_STATE_ENUM = 'SYSTEM_STATE_ENUM',
  SCHEDULE_STATE_ENUM = 'SCHEDULE_STATE_ENUM',
  DELIVERY_STATUS_ENUM = 'DELIVERY_STATUS_ENUM',
  VEHICLE_ONLINE_ENUM = 'VEHICLE_ONLINE_ENUM',
  VEHICLE_BUSINESS_TYPE_ENUM = 'VEHICLE_BUSINESS_TYPE_ENUM',
  ISSUE_OPERATE_RESULT_ENUM = 'ISSUE_OPERATE_RESULT_ENUM',
  ALARM_SOLUTION_ENUM = 'ALARM_SOLUTION_ENUM',
  STOP_TYPE_ENUM = 'STOP_TYPE_ENUM',
  DELIVERY_MODE_ENUM = 'DELIVERY_MODE_ENUM',
  STOP_ACTION_ENUM = 'STOP_ACTION_ENUM',
  ACCIDENT_STATUS_ENUM = 'ACCIDENT_STATUS_ENUM',
  ACCIDENT_SOURCE_ENUM = 'ACCIDENT_SOURCE_ENUM',
  ACCIDENT_TYPE_ENUM = 'ACCIDENT_TYPE_ENUM',
  BOOT_STATUS_ENUM = 'BOOT_STATUS_ENUM',
  TAG_ENUM = 'TAG_ENUM',
  ACCIDENT_LEVEL_ENUM = 'ACCIDENT_LEVEL_ENUM',
  BUG_MODULE_ENUM = 'BUG_MODULE_ENUM',
  BUG_SEVERITY_ENUM = 'BUG_SEVERITY_ENUM',
  MANUAL_ALARM_SOURCE_ENUM = 'MANUAL_ALARM_SOURCE_ENUM',
  ALARM_SOURCE_ENUM = 'ALARM_SOURCE_ENUM',
  COCKPIT_TYPE_ENUM = 'COCKPIT_TYPE_ENUM',
  ISSUE_STATUS_ENUM = 'ISSUE_STATUS_ENUM',
  PRELIMINARY_ACCIDENT_TYPE_ENUM = 'PRELIMINARY_ACCIDENT_TYPE_ENUM',
  ACCIDENT_OPERATION_STATUS_ENUM = 'ACCIDENT_OPERATION_STATUS_ENUM',
  SAFETY_GROUP_ACCIDENT_LEVEL_ENUM = 'SAFETY_GROUP_ACCIDENT_LEVEL_ENUM',
  SAFETY_GROUP_ACCIDENT_TYPE_ENUM = 'SAFETY_GROUP_ACCIDENT_TYPE_ENUM',
  ACCIDENT_RESOLUTION_STATUS_ENUM = 'ACCIDENT_RESOLUTION_STATUS_ENUM',
  BUG_STATUS_ENUM = 'BUG_STATUS_ENUM',

  ISSUE_FEEDBACK_TYPE_ENUM = 'ISSUE_FEEDBACK_TYPE_ENUM',
  REMOTE_CONTROL_FEEDBACK_TYPE_ENUM = 'REMOTE_CONTROL_FEEDBACK_TYPE_ENUM',
  ISSUE_FEEDBACK_STATUS_ENUM = 'ISSUE_FEEDBACK_STATUS_ENUM',
  ABNORMAL_FOLLOWUP_STATUS_ENUM = 'ABNORMAL_FOLLOWUP_STATUS_ENUM',
  ABNORMAL_FOLLOWUP_TYPE_ENUM = 'ABNORMAL_FOLLOWUP_TYPE_ENUM',
}

/**
 * 媒体类型枚举
 */
export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}
